module.exports = __webpack_public_path__ + "img/enp.a96dfab9.png";